import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const OpenedBookWithTextIcon = createIcon({
  displayName: 'OpenedBookWithTextIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15,13.757c0.961,-0.319 1.946,-0.522 3,-0.64"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6,13.118c1.054,0.117 2.039,0.321 3,0.64"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M18,9.118c-1.054,0.117 -2.039,0.321 -3,0.64"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M9,9.757c-0.961,-0.319 -1.946,-0.522 -3,-0.64"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12,6.131c-2.594,-1.453 -4.912,-2.031 -7.983,-2.13c-0.558,-0.019 -1.017,0.441 -1.017,1v11.853c0,0.541 0.433,0.99 0.974,0.998c3.092,0.046 5.42,0.616 8.026,2.148c2.606,-1.532 4.934,-2.102 8.026,-2.148c0.541,-0.008 0.974,-0.457 0.974,-0.999v-11.853c0,-0.559 -0.459,-1.018 -1.017,-1c-3.071,0.1 -5.389,0.678 -7.983,2.131Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12,6.13v13.87"
        ></path>
      </g>
    </>
  ),
})

const OpenedBookWithText: FC<IconProps> = (props) => {
  return <CustomIcon as={OpenedBookWithTextIcon} {...props} />
}

export default memo(OpenedBookWithText)
